/**
 * Converts an exact age to an age range string
 * For overlapping ages (22, 30), uses the younger range
 * 
 * @param {number} age - The exact age to convert
 * @returns {string} - The age range string (e.g., "18-22", "22-30", "30-40", "40+")
 */
export const getAgeRange = (age) => {
  if (!age || typeof age !== 'number') {
    return null;
  }

  if (age >= 18 && age <= 22) {
    return '18-22';
  } else if (age >= 23 && age <= 30) {
    return '22-30';
  } else if (age >= 31 && age <= 40) {
    return '30-40';
  } else if (age >= 41) {
    return '40+';
  }
  
  return null;
};

